// ===== DADOS EDITÁVEIS DA CREATIVE =====
// Altera aqui contactos, projetos e serviços sem tocar nos componentes.

export const CONTACT = {
  email: "creativeesm@gmail.com",
  instagram: "@creativeesm",
  instagramUrl: "https://www.instagram.com/creativeesm/",
};

export const NAV_LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "Sobre nós", href: "#sobre" },
  { label: "Projetos", href: "#projetos" },
  { label: "Contacto", href: "#contacto" },
];

export const SERVICES = [
  {
    n: "01",
    icon: "Compass",
    name: "Estratégia",
    desc: "Planeamento e definição de estratégias para posicionar marcas, comunicar melhor e alcançar objetivos concretos.",
  },
  {
    n: "02",
    icon: "TrendingUp",
    name: "Marketing",
    desc: "Estratégias de marketing, conteúdo e comunicação pensadas para gerar crescimento e criar ligação com o público.",
  },
  {
    n: "03",
    icon: "PenTool",
    name: "Design gráfico",
    desc: "Identidade visual, branding, peças gráficas, campanhas e conteúdos visuais.",
  },
  {
    n: "04",
    icon: "Camera",
    name: "Fotografia",
    desc: "Fotografia profissional para marcas, produtos, campanhas, redes sociais e comunicação.",
  },
  {
    n: "05",
    icon: "Clapperboard",
    name: "Vídeo",
    desc: "Produção e edição de vídeo para campanhas, redes sociais, publicidade e storytelling.",
  },
];

export const PROCESS = [
  {
    n: "01",
    title: "Descobrir",
    desc: "Percebemos a marca, o problema, o público e os objetivos.",
  },
  {
    n: "02",
    title: "Estratégia",
    desc: "Criamos uma direção estratégica clara.",
  },
  {
    n: "03",
    title: "Criar",
    desc: "Transformamos a estratégia em design, conteúdo, fotografia, vídeo e comunicação.",
  },
  {
    n: "04",
    title: "Crescer",
    desc: "Analisamos, ajustamos e procuramos gerar resultados reais.",
  },
];

export const PROJECTS = [
  {
    category: "Branding",
    summary: "Identidade visual completa: logotipo, paleta, tipografia e estacionário.",
    image: "/assets/project-branding.webp",
    wide: true,
  },
  {
    category: "Marketing",
    summary: "Estratégia de conteúdo e presença digital.",
    image: "/assets/project-marketing.webp",
    wide: false,
  },
  {
    category: "Fotografia",
    summary: "Produções fotográficas que valorizam as marcas, produtos, pessoas e momentos.",
    image: "/assets/project-fotografia.webp",
    wide: false,
  },
  {
    category: "Design",
    summary: "Soluções visuais que comunicam, destacam e dão personalidade à marca.",
    image: "/assets/project-design.webp",
    wide: false,
    contain: true,
  },
  {
    category: "Vídeo",
    summary: "Conteúdo visual que conta histórias, transmite emoções e dá vida à marca.",
    video: "/assets/project-video.mp4",
    wide: false,
  },
  {
    category: "Estratégia",
    summary: "Direção e posicionamento pensados para fazer a marca crescer.",
    image: "/assets/project-estrategia.webp",
    wide: false,
  },
];

export const FOUNDERS = [
  {
    name: "Diego",
    roles: "Design · Fotografia · Vídeo",
    bio: "O Diego é responsável pela área visual e criativa da agência: do design gráfico à fotografia e ao vídeo, dá forma e movimento às ideias de cada marca.",
    image: "/assets/diego.webp",
  },
  {
    name: "Michelle",
    roles: "Marketing · Estratégia",
    bio: "A Michelle lidera a estratégia e o marketing e acompanha cada marca de perto, do primeiro briefing aos resultados.",
    image: "/assets/michelle.webp",
  },
];

export const PILLARS = [
  {
    n: "01",
    title: "Comunicação direta",
    desc: "Falas diretamente com quem está a trabalhar no teu projeto.",
  },
  {
    n: "02",
    title: "Estratégia + Criatividade",
    desc: "Do planeamento à produção, tudo é pensado e executado com uma visão única.",
  },
  {
    n: "03",
    title: "Abordagem pessoal",
    desc: "Cada projeto é pensado de acordo com a marca.",
  },
  {
    n: "04",
    title: "Qualidade acima de quantidade",
    desc: "Preferimos fazer menos projetos e fazê-los realmente bem.",
  },
];

export const scrollToId = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
